<!-- @veltra/icons generated sha256:8360740e53ac56fb gen:8 source:src/svg/normal/male.svg -->
<script setup lang="ts">
defineOptions({ name: 'Male' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M13 3.6a.6.6 0 0 0-.6-.6H9.502A.5.5 0 0 0 9 3.5c0 .276.222.5.498.5h1.884l-3.71 3.71a3.5 3.5 0 1 0 .694.72L12 4.797v1.706c0 .276.224.497.5.497s.5-.227.5-.503zm-9.243 8.643a2.5 2.5 0 1 1 3.536-3.536 2.5 2.5 0 0 1-3.536 3.536"
    />
  </svg>
</template>
